import { useAppContext } from '@contexts/AppContext';
import { useXbmGetLoggedInUserDataQuery } from '@contexts/AppContext/getUserData.generated';

type Data = ReturnType<typeof useXbmGetLoggedInUserDataQuery>['data'];

type CurrentFlags = Record<'featureSwitches', string[]>;
type Viewer = Data['viewer'];
type CurrentUser = Record<'currentUser', Viewer & CurrentFlags>;

type UserLanguage = Omit<Viewer['accountSettings'], 'email'>;

type TotalBriefings = { numberOfBriefings: number };

type ContextData = Record<'data', CurrentUser & UserLanguage & TotalBriefings>;

const useCurrentSettings = () => {
  const {
    data: { language, currentUser, numberOfBriefings },
  } = useAppContext() as ContextData;

  return { language, numberOfBriefings, ...currentUser };
};

export { useCurrentSettings };
